import { ExtendedEventBaseItem } from "./extended-event-base.item";
import { RankingItem } from "./ranking.item";
import { FactoryService } from "../../wa-services/factory-service";
import { RankingCategoryItem } from "./ranking-category.item";
import { SeriesAmateursDetailItem } from "./series-amateurs-detail-item";
import { AthleteGeneralInfoItem } from "./athlete-general-info.item";

export class SeriesAmateursItem extends RankingItem {
  details: Array<SeriesAmateursDetailItem> = new Array();
  members: Array<AthleteGeneralInfoItem> = new Array();
  team: {
    TeamId: string;
    TeamName: string;
    TeamCatId: string;
    name: string;
    noc: string;
  };

  constructor(SeriesAmateursItemraw: any, waHelperService: FactoryService) {
    super(SeriesAmateursItemraw, waHelperService);
    this.details = SeriesAmateursItemraw.Details as any;
    this.athlete = SeriesAmateursItemraw.Athlete as any;
    this.catCode = SeriesAmateursItemraw.Cat;
    this.rank = SeriesAmateursItemraw.Rnk;
    this.rankPrevious = SeriesAmateursItemraw.RnkOld;
    this.score = SeriesAmateursItemraw.Score;
    this.team = SeriesAmateursItemraw.Team;
  }
}
